// Barrel & handle colors — one list, based on the Phoenix reference palette.
// Dark stains are lifted from the sampled swatch values so they stay distinguishable on the 3D bat.
// finish: "natural" = bare wood, no coating (always matte)
//         "stain"   = translucent, wood grain shows through
//         "solid"   = opaque, no grain
// tint (optional) overrides the multiply color used to stain the wood texture.
// effect (optional) swaps in a generated wood texture (see getFlameMap in bat-builder.liquid).
window.BAT_COLORS = [
  { id: "natural", name: "Natural (No Finish)", hex: "#C4B888", css: "#C4B888", finish: "natural" },
  { id: "clear", name: "Clear", hex: "#C2AE79", css: "#C2AE79", finish: "stain", tint: "#FCF1E3" },
  // effect "flame": torched-wood texture generated in the builder instead of a flat tint
  { id: "flame", name: "Flame", hex: "#7D5135", css: "linear-gradient(160deg,#A06A3E 0%,#6A4426 35%,#36200F 62%,#84552E 100%)", finish: "stain", effect: "flame" },
  { id: "black", name: "Black", hex: "#0F0F0F", css: "#0F0F0F", finish: "solid" },
  { id: "smoke", name: "Smoke", hex: "#444B54", css: "#444B54", finish: "stain" },
  { id: "gray", name: "Gray", hex: "#828A96", css: "#828A96", finish: "stain" },
  { id: "wine", name: "Wine", hex: "#6A1C22", css: "#6A1C22", finish: "stain" },
  { id: "port", name: "Port", hex: "#7A2E1E", css: "#7A2E1E", finish: "stain" },
  { id: "java", name: "Java", hex: "#5A3A24", css: "#5A3A24", finish: "stain" },
  { id: "nutmeg", name: "Nutmeg", hex: "#86502C", css: "#86502C", finish: "stain" },
  { id: "navy", name: "Navy", hex: "#1E3A64", css: "#1E3A64", finish: "stain" },
  { id: "royal", name: "Royal", hex: "#1C4CA8", css: "#1C4CA8", finish: "stain" },
  { id: "carolina", name: "Carolina", hex: "#4A8BA7", css: "#4A8BA7", finish: "stain" },
  { id: "green", name: "Green", hex: "#2C5E3E", css: "#2C5E3E", finish: "stain" },
  { id: "red", name: "Red", hex: "#A61A1B", css: "#A61A1B", finish: "stain" },
  { id: "orange", name: "Orange", hex: "#CB440A", css: "#CB440A", finish: "stain" },
  { id: "pink", name: "Pink", hex: "#B32265", css: "#B32265", finish: "stain" },
  { id: "purple", name: "Purple", hex: "#5E2386", css: "#5E2386", finish: "stain" },
  { id: "yellow", name: "Yellow", hex: "#E9C928", css: "#E9C928", finish: "stain" },
];

window.BAT_LOGOS = [
  {
    id: "white",
    name: "White",
    hex: "#FFFFFF",
    category: "Solid Colors",
    type: "solid",
  },
  {
    id: "matte-white",
    name: "Matte White",
    hex: "#F0F0F0",
    category: "Solid Colors",
    type: "solid",
  },
  {
    id: "light-grey",
    name: "Light Grey",
    hex: "#D3D3D3",
    category: "Solid Colors",
    type: "solid",
  },
  {
    id: "silver-metallic",
    name: "Silver Metallic",
    hex: "#C0C0C0",
    category: "Solid Colors",
    type: "solid",
  },
  {
    id: "dark-grey",
    name: "Dark Grey",
    hex: "#555555",
    category: "Solid Colors",
    type: "solid",
  },
  {
    id: "dark-charcoal-metallic",
    name: "Dark Charcoal Metallic",
    hex: "#333333",
    category: "Solid Colors",
    type: "solid",
  },
  {
    id: "black",
    name: "Black",
    hex: "#111111",
    category: "Solid Colors",
    type: "solid",
  },
  {
    id: "matte-black",
    name: "Matte Black",
    hex: "#222222",
    category: "Solid Colors",
    type: "solid",
  },
  {
    id: "brown",
    name: "Brown",
    hex: "#654321",
    category: "Solid Colors",
    type: "solid",
  },
  {
    id: "red",
    name: "Red",
    hex: "#CC0000",
    category: "Solid Colors",
    type: "solid",
  },
  {
    id: "burgundy",
    name: "Burgundy",
    hex: "#800020",
    category: "Solid Colors",
    type: "solid",
  },
  {
    id: "orange",
    name: "Orange",
    hex: "#FF8800",
    category: "Solid Colors",
    type: "solid",
  },
  {
    id: "yellow",
    name: "Yellow",
    hex: "#FFCC00",
    category: "Solid Colors",
    type: "solid",
  },
  {
    id: "gold",
    name: "Gold",
    hex: "#D4AF37",
    category: "Solid Colors",
    type: "solid",
  },
  {
    id: "emerald-green",
    name: "Emerald Green",
    hex: "#50C878",
    category: "Solid Colors",
    type: "solid",
  },
  {
    id: "dark-green-metallic",
    name: "Dark Green Metallic",
    hex: "#1B4D3E",
    category: "Solid Colors",
    type: "solid",
  },
  {
    id: "forest-green",
    name: "Forest Green",
    hex: "#228B22",
    category: "Solid Colors",
    type: "solid",
  },
  {
    id: "real-teal",
    name: "Real Teal",
    hex: "#008080",
    category: "Solid Colors",
    type: "solid",
  },
  {
    id: "olympic-blue",
    name: "Olympic Blue",
    hex: "#008ECC",
    category: "Solid Colors",
    type: "solid",
  },
  {
    id: "bright-blue-metallic",
    name: "Bright Blue Metallic",
    hex: "#2A52BE",
    category: "Solid Colors",
    type: "solid",
  },
  {
    id: "blue",
    name: "Blue",
    hex: "#0000CC",
    category: "Solid Colors",
    type: "solid",
  },
  {
    id: "royal-purple",
    name: "Royal Purple",
    hex: "#7851A9",
    category: "Solid Colors",
    type: "solid",
  },
  {
    id: "magenta",
    name: "Magenta",
    hex: "#FF00FF",
    category: "Solid Colors",
    type: "solid",
  },

  // --- SMOOTH HOLOGRAPHIC ---
  {
    id: "holo-silver",
    name: "Silver Holographic",
    hex: "#C0C0C0",
    category: "Smooth Holographic",
    type: "holographic",
    image: "holo_silver.png",
  },
  {
    id: "holo-gold",
    name: "Gold Holographic",
    hex: "#D4AF37",
    category: "Smooth Holographic",
    type: "holographic",
    image: "holo_gold.png",
  },
  {
    id: "holo-gunmetal",
    name: "Gunmetal Grey Holographic",
    hex: "#484848",
    category: "Smooth Holographic",
    type: "holographic",
    image: "holo_gunmetal.png",
  },
  {
    id: "holo-rosegold",
    name: "Rose Gold Holographic",
    hex: "#B76E79",
    category: "Smooth Holographic",
    type: "holographic",
    image: "holo_rose_gold.png",
  },
  {
    id: "holo-pink",
    name: "Pink Holographic",
    hex: "#FFC0CB",
    category: "Smooth Holographic",
    type: "holographic",
    image: "holo_pink.png",
  },
  {
    id: "holo-magenta",
    name: "Magenta Holographic",
    hex: "#FF00FF",
    category: "Smooth Holographic",
    type: "holographic",
    image: "holo_magenta.png",
  },
  {
    id: "holo-cherry",
    name: "Cherry Red Holographic",
    hex: "#D2042D",
    category: "Smooth Holographic",
    type: "holographic",
    image: "holo_cherry_red.png",
  },
  {
    id: "holo-orange",
    name: "Orange Holographic",
    hex: "#FF8C00",
    category: "Smooth Holographic",
    type: "holographic",
    image: "holo_orange.png",
  },
  {
    id: "holo-violet",
    name: "Violet Holographic",
    hex: "#EE82EE",
    category: "Smooth Holographic",
    type: "holographic",
    image: "holo_violet.png",
  },
  {
    id: "holo-purple",
    name: "Purple Holographic",
    hex: "#800080",
    category: "Smooth Holographic",
    type: "holographic",
    image: "holo_purple.png",
  },
  {
    id: "holo-royal",
    name: "Royal Blue Holographic",
    hex: "#4169E1",
    category: "Smooth Holographic",
    type: "holographic",
    image: "holo_royal_blue.png",
  },
  {
    id: "holo-teal",
    name: "Teal Holographic",
    hex: "#008080",
    category: "Smooth Holographic",
    type: "holographic",
    image: "holo_teal.png",
  },
  {
    id: "holo-fluorgreen",
    name: "Fluorescent Green Holographic",
    hex: "#00FF00",
    category: "Smooth Holographic",
    type: "holographic",
    image: "holo_flo_green.png",
  },
  {
    id: "holo-emerald",
    name: "Emerald Holographic",
    hex: "#50C878",
    category: "Smooth Holographic",
    type: "holographic",
    image: "holo_emerald.png",
  },

  /*
  // --- SEQUINS HOLOGRAPHIC ---
  {
    id: "sequins-silver",
    name: "Silver Sequins",
    hex: "#C0C0C0",
    category: "Sequins Holographic",
    type: "holographic",
    image: "sequins_silver.png",
  },
  {
    id: "sequins-gold",
    name: "Gold Sequins",
    hex: "#D4AF37",
    category: "Sequins Holographic",
    type: "holographic",
    image: "sequins_gold.png",
  },
  {
    id: "sequins-copper",
    name: "Copper Sequins",
    hex: "#B87333",
    category: "Sequins Holographic",
    type: "holographic",
    image: "sequins_copper.png",
  },
  {
    id: "sequins-gunmetal",
    name: "Gunmetal Sequins",
    hex: "#484848",
    category: "Sequins Holographic",
    type: "holographic",
    image: "sequins_gunmetal.png",
  },
  {
    id: "sequins-red",
    name: "Red Sequins",
    hex: "#FF0000",
    category: "Sequins Holographic",
    type: "holographic",
    image: "sequins_red.png",
  },
  {
    id: "sequins-pink",
    name: "Pink Sequins",
    hex: "#FFC0CB",
    category: "Sequins Holographic",
    type: "holographic",
    image: "sequins_pink.png",
  },
  {
    id: "sequins-magenta",
    name: "Magenta Sequins",
    hex: "#FF00FF",
    category: "Sequins Holographic",
    type: "holographic",
    image: "sequins_magenta.png",
  },
  {
    id: "sequins-orange",
    name: "Orange Sequins",
    hex: "#FF8C00",
    category: "Sequins Holographic",
    type: "holographic",
    image: "sequins_orange.png",
  },
  {
    id: "sequins-purple",
    name: "Purple Sequins",
    hex: "#800080",
    category: "Sequins Holographic",
    type: "holographic",
    image: "sequins_purple.png",
  },
  {
    id: "sequins-violet",
    name: "Violet Sequins",
    hex: "#EE82EE",
    category: "Sequins Holographic",
    type: "holographic",
    image: "sequins_violet.png",
  },
  {
    id: "sequins-royal",
    name: "Royal Blue Sequins",
    hex: "#4169E1",
    category: "Sequins Holographic",
    type: "holographic",
    image: "sequins_royal_blue.png",
  },
  {
    id: "sequins-teal",
    name: "Teal Sequins",
    hex: "#008080",
    category: "Sequins Holographic",
    type: "holographic",
    image: "sequins_teal.png",
  },
  {
    id: "sequins-emerald",
    name: "Emerald Sequins",
    hex: "#50C878",
    category: "Sequins Holographic",
    type: "holographic",
    image: "sequins_emerald.png",
  },

  // --- CRYSTAL HOLOGRAPHIC ---
  {
    id: "crystal-silver",
    name: "Silver Crystal",
    hex: "#C0C0C0",
    category: "Crystal Holographic",
    type: "holographic",
    image: "crystal_silver.png",
  },
  {
    id: "crystal-gold",
    name: "Gold Crystal",
    hex: "#D4AF37",
    category: "Crystal Holographic",
    type: "holographic",
    image: "crystal_gold.png",
  },
  {
    id: "crystal-gunmetal",
    name: "Gunmetal Crystal",
    hex: "#484848",
    category: "Crystal Holographic",
    type: "holographic",
    image: "crystal_gunmetal.png",
  },
  {
    id: "crystal-cherry",
    name: "Cherry Red Crystal",
    hex: "#D2042D",
    category: "Crystal Holographic",
    type: "holographic",
    image: "crystal_cherry_red.png",
  },
  {
    id: "crystal-orange",
    name: "Orange Crystal",
    hex: "#FF8C00",
    category: "Crystal Holographic",
    type: "holographic",
    image: "crystal_orange.png",
  },
  {
    id: "crystal-purple",
    name: "Purple Crystal",
    hex: "#800080",
    category: "Crystal Holographic",
    type: "holographic",
    image: "crystal_purple.png",
  },
  {
    id: "crystal-violet",
    name: "Violet Crystal",
    hex: "#EE82EE",
    category: "Crystal Holographic",
    type: "holographic",
    image: "crystal_violet.png",
  },
  {
    id: "crystal-royal",
    name: "Royal Blue Crystal",
    hex: "#4169E1",
    category: "Crystal Holographic",
    type: "holographic",
    image: "crystal_royal_blue.png",
  },
  {
    id: "crystal-teal",
    name: "Teal Crystal",
    hex: "#008080",
    category: "Crystal Holographic",
    type: "holographic",
    image: "crystal_teal.png",
    texture: "turquoise.jpg",
  },
  */

  // --- PRISM HOLOGRAPHIC ---
  {
    id: "prism-silver-mosaic",
    name: "Silver Mosaic Prism",
    hex: "#ABACB3",
    category: "Prism Holographic",
    type: "holographic",
    image: "prism_silver_mosaic.png",
    texture: "prism_silver_mosaic2.png"
  },
  {
    id: "prism-silver-plaid",
    name: "Silver Plaid Prism",
    hex: "#958C8C",
    category: "Prism Holographic",
    type: "holographic",
    image: "prism_silver_plaid.png",
    texture: "prism_silver_plaid2.png"
  },
  {
    id: "prism-gold-mosaic",
    name: "Gold Mosaic Prism",
    hex: "#D4AF37",
    category: "Prism Holographic",
    type: "holographic",
    image: "prism_gold_mosaic.png",
    texture: "prism_gold_mosaic2.png"
  },
  {
    id: "prism-gunmetal-mosaic",
    name: "Gunmetal Mosaic Prism",
    hex: "#979C9D",
    category: "Prism Holographic",
    type: "holographic",
    image: "prism_gunmetal_mosaic.png",
  },
  {
    id: "prism-red-mosaic",
    name: "Red Mosaic Prism",
    hex: "#FF0000",
    category: "Prism Holographic",
    type: "holographic",
    image: "prism_red_mosaic.png",
    texture: "prism_red_mosaic2.png"
  },
  {
    id: "prism-orange-mosaic",
    name: "Orange Mosaic Prism",
    hex: "#F47801",
    category: "Prism Holographic",
    type: "holographic",
    image: "prism_orange_mosaic.png",
    texture: "prism_orange_mosaic2.png"
  },
  {
    id: "prism-orange-plaid",
    name: "Orange Plaid Prism",
    hex: "#AB4902",
    category: "Prism Holographic",
    type: "holographic",
    image: "prism_orange_plaid.png",
  },
  {
    id: "prism-purple-mosaic",
    name: "Purple Mosaic Prism",
    hex: "#3B1B87",
    category: "Prism Holographic",
    type: "holographic",
    image: "prism_purple_mosaic.png",
    texture: "prism_purple_mosaic2.png"
  },
  {
    id: "prism-violet-mosaic",
    name: "Violet Mosaic Prism",
    hex: "#564C8A",
    category: "Prism Holographic",
    type: "holographic",
    image: "prism_violet_mosaic.png",
    texture: "prism_violet_mosaic2.png"
  },
  {
    id: "prism-royal-mosaic",
    name: "Royal Blue Mosaic Prism",
    hex: "#4169E1",
    category: "Prism Holographic",
    type: "holographic",
    image: "prism_royal_blue_mosaic.png",
    texture: "prism_royal_blue_mosaic2.png"
  },
  {
    id: "prism-sky-mosaic",
    name: "Sky Blue Mosaic Prism",
    hex: "#6BB8E8",
    category: "Prism Holographic",
    type: "holographic",
    image: "prism_sky_blue_mosaic.png",
    texture: "prism_sky_blue_mosaic2.png"
  },
  {
    id: "prism-emerald-mosaic",
    name: "Emerald Mosaic Prism",
    hex: "#0BE83A",
    category: "Prism Holographic",
    type: "holographic",
    image: "prism_emerald_mosaic.png",
    texture: "prism_emerald_mosaic2.png"
  },
  {
    id: "prism-magenta-mosaic",
    name: "Magenta Mosaic Prism",
    hex: "#CD06CE",
    category: "Prism Holographic",
    type: "holographic",
    image: "prism_magenta_mosaic.png",
    texture: "prism_magenta_mosaic2.png"
  },

  // --- ENGINE TURN ---
  {
    id: "engine-gold-large",
    name: "Gold Large Engine Turn",
    hex: "#D4AF37",
    category: "Engine Turn",
    type: "holographic",
    image: "engine_turn_gold_large.png",
    texture: "engineturn-gold-large.png",
  },
  {
    id: "engine-gold-small",
    name: "Gold Small Engine Turn",
    hex: "#D4AF37",
    category: "Engine Turn",
    type: "holographic",
    image: "engine_turn_gold_small.png",
    texture: "engineturn-gold-small.png",
  },
  {
    id: "engine-silver-large",
    name: "Silver Large Engine Turn",
    hex: "#C0C0C0",
    category: "Engine Turn",
    type: "holographic",
    image: "engine_turn_silver_large.png",
    texture: "engineturn-silver-large.png",
  },
  {
    id: "engine-silver-small",
    name: "Silver Small Engine Turn",
    hex: "#C0C0C0",
    category: "Engine Turn",
    type: "holographic",
    image: "engine_turn_silver_small.png",
    texture: "engineturn-silver-small.png",
  },

  /*
  // --- LEAF ---
  {
    id: "leaf-gold",
    name: "Gold Leaf",
    hex: "#D4AF37",
    category: "Leaf",
    type: "holographic",
    image: "leaf_gold.png",
  },
  {
    id: "leaf-silver",
    name: "Silver Leaf",
    hex: "#C0C0C0",
    category: "Leaf",
    type: "holographic",
    image: "leaf_silver.png",
  },
  */

  // --- DIAMOND PLATE & CARBON FIBER ---
  {
    id: "carbon-fiber",
    name: "Carbon Fiber",
    hex: "#111111",
    category: "Diamond Plate & Carbon Fiber",
    type: "holographic",
    image: "carbon_fiber.png",
  },
  {
    id: "diamond-plate",
    name: "Silver Diamond Plate",
    hex: "#C0C0C0",
    category: "Diamond Plate & Carbon Fiber",
    type: "holographic",
    image: "silver_diamond_plate.png",
  },

  /*
  // --- TRANSPARENT COLORSHIFT ---
  {
    id: "shift-flare",
    name: "Flare Transparent",
    hex: "#330a00",
    category: "Transparent Colorshift",
    type: "colorshift",
    ior: 1.8,
    image: "transparent_flare.png",
  },
  {
    id: "shift-aurora",
    name: "Violet Aurora Transparent",
    hex: "#1a0033",
    category: "Transparent Colorshift",
    type: "colorshift",
    ior: 2.2,
    image: "transparent_violet_aurora.png",
  },
  {
    id: "shift-nebula",
    name: "Nebula Transparent",
    hex: "#001233",
    category: "Transparent Colorshift",
    type: "colorshift",
    ior: 1.45,
    image: "transparent_nebula.png",
  },
  */
];

window.getBarrelHandleColor = function (id) {
  return window.BAT_COLORS.find((c) => c.id === id) || window.BAT_COLORS[0];
};

window.getBatColor = function (id) {
  // Barrel/handle and logo ids overlap (e.g. "black"), so use getBarrelHandleColor for those.
  return window.BAT_LOGOS.find((c) => c.id === id) || window.BAT_COLORS.find((c) => c.id === id);
};
